<template>
  <div class="signup app-content bg-gray">
    <div class="container">
      <div class="row pt-4 ">
        <div class="col-12">
          <router-link :to="'./mypage'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
          </router-link> 
          <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
          <router-link :to="'./pastedQuiz'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.profile_setting")}}</p>
          </router-link> 
        </div>
      </div>

      <div class="row mt-4 pb-5">
        <div class="col-12">
          <h5>{{$t("message.profile_setting")}}</h5>
        </div>

        <div class="col-12">
          <b-card>
            <div class="col-12 col-md-5 pt-mobile-0">
              <create-profile ref="profileInfo"></create-profile>  
              <b-button class="navLogin mt-4 px-5 ml-3" @click='registProfile'>{{$t("message.save")}}</b-button>
            </div>
            
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
import CreateProfile from "@/components/User/Setting/CreateProfile"
export default {
  components: {
    CreateProfile,
  },
  data () {
    return {
      email: ''
    }
  },
  methods: {
    registProfile(){
      return new Promise((resolve, reject) => {
          this.$refs.profileInfo.regist_member().then(value =>{
            if(value){
              this.$swal.fire({
                icon: 'success',
                title: this.$i18n.t('message.change_success')
              })
            }else{
              reject()
            }
          })
       })
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.outh,
      memberInfo: state => state.user.user
    }),
  },
  mounted(){
    this.$store.commit('setLoading', false)
  },

}
</script>

<style scoped>
.dirty {
    border-color: #F5F5F8;
    background: #F5F5F8;
    width: 100%;
}


</style>
